import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useThemeMode from "../hooks/useThemeMode";
import { getMarketingTheme } from "../utils/marketingTheme";
import useI18n from "../i18n/useI18n";

function Footer() {
  const { isDark } = useThemeMode();
  const { t } = useI18n();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  const tt = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };

  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: colors.cardBg,
        borderTop: `1px solid ${colors.border}`,
        marginTop: "40px",
        backdropFilter: isDark ? "blur(14px)" : "none",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "24px 16px",
          display: "flex",
          flexDirection: "column",
          gap: "14px",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: "700",
            color: colors.text,
          }}
        >
          Hookora
        </div>

        <div
          style={{
            color: colors.textMuted,
            fontSize: "14px",
            lineHeight: "1.7",
            maxWidth: "720px",
          }}
        >
          {tt(
            "footer.description",
            "Hookora is an AI-powered social media workflow platform for generating hooks, titles, captions, scripts, hashtags, and more."
          )}
        </div>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "14px",
            marginTop: "6px",
          }}
        >
          <Link to="/features" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("common.features", "Features")}
          </Link>
          <Link to="/pricing" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("common.pricing", "Pricing")}
          </Link>
          <Link to="/blog" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("common.blog", "Blog")}
          </Link>
          <Link to="/refund-policy" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("footer.refundPolicy", "Refund Policy")}
          </Link>
          <Link to="/privacy-policy" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("footer.privacyPolicy", "Privacy Policy")}
          </Link>
          <Link to="/terms" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("footer.terms", "Terms")}
          </Link>
          <Link to="/contact-support" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("footer.contactSupport", "Contact & Support")}
          </Link>
          <Link to="/login" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("common.login", "Login")}
          </Link>
          <Link to="/register" style={{ ...linkStyle, color: colors.textSoft }}>
            {tt("common.register", "Register")}
          </Link>
        </div>

        <div
          style={{
            marginTop: "10px",
            color: colors.textMuted,
            fontSize: "13px",
          }}
        >
          {tt("footer.copyright", `© ${year} Hookora. All rights reserved.`).replace(
            "{{year}}",
            String(year)
          )}
        </div>
      </div>
    </footer>
  );
}

const linkStyle = {
  textDecoration: "none",
  fontWeight: "500",
};

export default Footer;